$(document).ready(function() {
    // Ensure the script runs after the OneTrust SDK is loaded
    setTimeout(function() {
        $('.ot-close-icon').click(function() {
            $('.onetrust-pc-dark-filter.ot-fade-in').hide();
            $('.ot-sdk-show-settings').addClass('hover-effect');
        });

        $('.ot-sdk-show-settings').click(function() {
            $('a.privacy-notice-link').attr('href', 'https://shop.linksys.com/blogs/support-article/linksys-privacy-policy');
        });

        var button = document.querySelector('.ot-sdk-show-settings.update-cookie-btn');
        if (button) {
            button.textContent = 'Update Cookie Preferences';
        }
    }, 1000);

});